import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';


@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    imports: [ReactiveFormsModule, FormlyModule]
})
export class CheckboxComponent extends FieldType<FieldTypeConfig> {
  defaultOptions = {
    props: {
      indeterminate: true,
      hideLabel: true
    }
  };

  get checkboxFormControl() {
    return this.formControl as FormControl;
  }
}
